import Alert from 'components/Alert';

const handleApiExceptions = (response) => {
  try {
    let errorMessage = '';
    if (typeof response === 'string') errorMessage = response;
    else if (response && response.status && [401, 503, 403].includes(response.status)) return;
    else if (response && response.message) errorMessage = response.message;
    else if (response && response.data && response.data.message)
      errorMessage = response.data.message;
    Alert('Oops!!!', errorMessage || 'Something went wrong. Try again.', 'error');
  } catch (error) {
    Alert('Oops!!!', 'Something went wrong. Try again.', 'error');
  }
};

export default handleApiExceptions;
